import React, { Component } from "react";
import { Table, Modal, Input, Select, message, Button, Anchor, Popconfirm } from "antd";
import {
  getCollListInAtlas,
  updateHomeRecommend,
  updateHomeOrder,
  updateVip
} from "../../../api/inspiration";
import { isNumber } from "lodash";
import Zmage from "react-zmage";
import UploadCollModal from './UploadCollModal';
import CheckModal from './CheckModal';
import "./index.css";

const { Option } = Select;
message.config({
  maxCount: 1,
});

const collSourceList = [
  {
    label: '全部',
    value: 0
  },
  {
    label: '知末自营',
    value: 1
  },
  {
    label: '系统抓取',
    value: 2
  },
];

const PAGESIZE = 100;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
      pageNum: 1,
      searchId: '',
      collName: '',
      collSource: 0,
      homePageRecommend: -1,
      orderByCollCreateTime: 1, // 倒序-1，升序-2，不排序-''
      orderByHomeOrder: '', // 同上
      loading: false,
      dataSource: [],
      selectIds: [],
      uploadAddModal: false,
      checkModalVisible: false,
      checkCollId: '',
      isVip: -1
    };

    this.columns = [
      {
        title: "入库时间",
        dataIndex: "createtime",
        key: "createtime",
        sorter: true,
        defaultSortOrder: 'descend'
      },
      {
        title: "图集ID",
        dataIndex: "collId",
        key: "collId",
      },
      {
        title: "图集名称",
        dataIndex: "collName",
        key: "collName",
        width: '200px'
      },
      {
        title: "图集描述",
        dataIndex: "description",
        key: "description",
        width: '200px'
      },
      {
        title: "封面图",
        dataIndex: "homePageCover",
        key: "homePageCover",
        render: (data) => {
          if (data) {
            return <Zmage preset="desktop" zIndex={1000} src={data} style={{ width: 100, height: 60 }} />
          } else {
            return <div>暂无</div>
          }
        },
      },
      {
        title: "图片数量",
        dataIndex: "count",
        key: "count",
      },
      {
        title: "图集来源",
        dataIndex: "collSource",
        key: "collSource",
        render: data => {
          return <span>{data == 1 ? '知末自营' : '系统抓取'}</span>
        },
      },
      {
        title: "首页排序",
        dataIndex: "homeOrder",
        key: "homeOrder",
        sorter: true,
        render: (r, item) => <Input disabled={!r} type="number" style={{ width: 100 }} defaultValue={r || ''} onPressEnter={e => this.updateOrder(e, item)} />
      },
      {
        title: "操作",
        dataIndex: "opt",
        key: "opt",
        render: (opt, data) => {
          return (
            <>
              <Button onClick={() => this.showModal(data)}>查看</Button>
              <Popconfirm
                title={`是否确定将该图集${data.homeOrder ? '取消' : '设为'}首页推荐？`}
                onConfirm={() => this.updateRecommend(data.collId, data.homeOrder ? 0 : 1)}
                okText="确定"
                cancelText="取消"
              >
                {
                  data.homeOrder ? <Button style={{ marginLeft: 15 }} type="danger">取消首页推荐</Button>
                    : <Button style={{ marginLeft: 15 }} type="primary">设为首页推荐</Button>
                }
              </Popconfirm>
              <Popconfirm
                title={`是否确定将该图集${data?.isVip ? '取消' : '设为'}VIP图集？`}
                onConfirm={() => this.updateVipType(data.collId, data?.isVip ? 0 : 1)}
                okText="确定"
                cancelText="取消"
              >
                {
                  data?.isVip ? <Button style={{ marginLeft: 15 }} type="danger">取消VIP图集</Button>
                    : <Button style={{ marginLeft: 15 }} type="primary">设为VIP图集</Button>
                }
              </Popconfirm>
            </>
          );
        },
      },
    ];
  }

  componentDidMount() {
    // this.getList({...this.state});
  }

  handleChangeForCollSource = collSource => {
    this.setState({ collSource });
  };

  handleChangeForHomePageRecommend = homePageRecommend => {
    this.setState({ homePageRecommend });
  };
  handleChangeForisVip = isVip => {
    this.setState({ isVip });
  };

  handleInputChange = e => {
    this.setState({
      searchId: e.target.value
    });
  }

  getList = async params => {
    if (this.state.loading) return;
    this.setState({ dataSource: [] });
    this.setState({ loading: true });
    const { pageNum, searchId, collName, collSource, homePageRecommend, orderByCollCreateTime, orderByHomeOrder, isVip } = params;
    const res = await getCollListInAtlas({
      page: isNumber(pageNum) ? pageNum : 1,
      size: PAGESIZE,
      collId: searchId ?? '',
      collName: collName ?? '',
      collSource: collSource || '',
      homePageRecommend: homePageRecommend == -1 ? '' : homePageRecommend,
      isVip: isVip == -1 ? '' : isVip,
      orderByCollCreateTime,
      orderByHomeOrder
    })
    this.setState({
      ...params,
      pageNum: res?.data?.list?.length > 0 ? (isNumber(pageNum) ? pageNum : 1) : 1,
      dataSource: res?.data?.list ? res.data.list.map((v, i) => ({ ...v, index: isNumber(pageNum) ? (pageNum - 1) * 20 + i + 1 : i + 1 })) : [],
      totalCount: parseInt(res?.data?.totalCount ?? 1),
      loading: false,
    })
  };

  onTableChange = (pagination, filters, sorter) => {
    console.log(pagination, sorter);
    const params = {
      ...this.state,
      pageNum: pagination.current
    }
    const order = sorter.order ? (sorter.order == "ascend" ? 2 : 1) : '';
    switch (sorter.columnKey) {
      case "createtime":
        params.orderByCollCreateTime = order;
        params.orderByHomeOrder = '';
        this.getList(params);
        break;
      case "homeOrder":
        params.orderByCollCreateTime = '';
        params.orderByHomeOrder = order;
        this.getList(params);
        break;
      default:
        params.orderByCollCreateTime = '';
        params.orderByHomeOrder = '';
        this.getList(params);
    }

  };

  search = () => {
    this.getList({
      ...this.state,
      pageNum: 1
    });
  };

  clearAll = () => {
    this.getList({
      pageNum: 1,
      searchId: '',
      collName: '',
      collSource: 0,
      homePageRecommend: -1,
      orderByCollCreateTime: 1,
      orderByHomeOrder: '',
      isVip: -1
    });
  };

  showUploadModal = () => {
    this.setState({ uploadAddModal: true });
  };

  updateOrder = async (e, item) => {
    if (item.homeOrder != e.currentTarget.value) {
      const res = await updateHomeOrder({
        collId: item.collId,
        orderValue: e.currentTarget.value
      });
      if (res?.error?.code == 0 && res.data) {
        message.success('设置成功');
        this.getList({ ...this.state });
      } else if (res?.error?.code != 0 && res?.error?.message) {
        message.error(res.error.message);
      } else {
        message.error('设置失败');
      }
    }
  };

  updateRecommend = async (collId, type) => {
    const res = await updateHomeRecommend({
      collIds: [collId],
      type
    });
    if (res?.error?.code == 0 && res.data) {
      message.success('设置成功');
      this.getList({ ...this.state });
    } else if (res?.error?.code != 0 && res?.error?.message) {
      message.error(res.error.message);
    } else {
      message.error('设置失败');
    }
  };

  // 修改图集VIP状态
  updateVipType = async (collId, isVip) => {
    const res = await updateVip({ collId, isVip })
    if (res?.error?.code == 0 && res.data) {
      message.success('设置成功');
      this.getList({ ...this.state });
    } else {
      message.error('设置失败')
    }
  }

  onUpLoadModelOk = () => {
    this.setState({ uploadAddModal: false });
    this.getList({
      ...this.state,
      pageNum: 1
    });
  };

  onUpLoadModelCancel = () => {
    this.setState({ uploadAddModal: false });
  };

  showModal = async data => {
    this.setState({
      checkModalVisible: true,
      checkCollId: data.collId
    });
  };

  onCheckModelOk = () => {
    this.setState({ checkModalVisible: false });
    this.getList({
      ...this.state,
      pageNum: 1
    });
  };

  onCheckModelCancel = () => {
    this.setState({ checkModalVisible: false });
  };

  render() {
    const { checkModalVisible, collSource, searchId, homePageRecommend, totalCount, dataSource, checkCollId, collName, loading, uploadAddModal, pageNum, isVip } = this.state;
    const paginationProps = {
      defaultPageSize: PAGESIZE,
      total: totalCount,
      current: pageNum,
    }
    return (
      <div className="atlasManager_container">
        <div className="atlasManager_header">图集管理&gt;图集推荐</div>
        <div className="atlasManager_content">
          <Anchor>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                height: 80
              }}
            >
              <span style={{ width: 60 }}>图集ID:</span>
              <Input
                placeholder="请输入"
                style={{ width: 150, marginLeft: 10 }}
                value={searchId}
                onChange={e => this.setState({ searchId: e.target.value })}
              />
              <span style={{ width: 60, marginLeft: 30 }}>图集名称:</span>
              <Input
                placeholder="请输入"
                style={{ width: 150, marginLeft: 10 }}
                value={collName}
                onChange={e => this.setState({ collName: e.target.value })}
              />
              <span style={{ width: 60, marginLeft: 30 }}>图集来源:</span>
              <Select
                placeholder="图集来源"
                style={{ width: 120, marginLeft: 10 }}
                value={collSource}
                onChange={v => this.handleChangeForCollSource(v)}
              >
                {collSourceList.map(v =>
                  <Option key={v.value} value={v.value}>
                    {v.label}
                  </Option>)}
              </Select>
              <span style={{ width: 90, marginLeft: 30 }}>是否VIP图集:</span>
              <Select
                placeholder="是否VIP图集"
                style={{ width: 120, marginLeft: 10 }}
                value={isVip}
                onChange={v => this.handleChangeForisVip(v)}
              >
                <Option key={-1} value={-1}>
                  全部
                </Option>
                <Option key={1} value={1}>
                  是
                </Option>
                <Option key={0} value={0}>
                  否
                </Option>
              </Select>
              <span style={{ width: 90, marginLeft: 30 }}>是否首页推荐:</span>
              <Select
                placeholder="是否首页推荐"
                style={{ width: 120, marginLeft: 10, marginRight: 30 }}
                value={homePageRecommend}
                onChange={v => this.handleChangeForHomePageRecommend(v)}
              >
                <Option key={-1} value={-1}>
                  全部
                </Option>
                <Option key={1} value={1}>
                  是
                </Option>
                <Option key={0} value={0}>
                  否
                </Option>
              </Select>
              <Button
                type="danger"
                style={{ width: 80, marginLeft: 30 }}
                onClick={this.clearAll}
                loading={loading}
              >
                清空
              </Button>
              <Button
                type="primary"
                style={{ width: 80, marginLeft: 30 }}
                onClick={this.search}
                loading={loading}
              >
                查询
              </Button>
            </div>
          </Anchor>
          <div className="btn_wrap">
            <Button
              type="primary"
              onClick={this.showUploadModal}
              icon='upload'
            >
              上传图集
            </Button>
          </div>
          <Table
            bordered
            loading={loading}
            dataSource={dataSource}
            columns={this.columns}
            style={{ marginTop: 20 }}
            pagination={paginationProps}
            rowKey={(record) => record.collId}
            onChange={this.onTableChange}
          />
        </div>

        <UploadCollModal uploadAddModal={uploadAddModal} onCancel={this.onUpLoadModelCancel} onOk={this.onUpLoadModelOk} />
        <CheckModal modalVisible={checkModalVisible} onCancel={this.onCheckModelCancel} onOk={this.onCheckModelOk} collId={checkCollId} />

      </div>
    );
  }
}

export default Index;
